import { render, staticRenderFns } from "./ListCourses.vue?vue&type=template&id=06dbe27e&scoped=true&"
import script from "./ListCourses.vue?vue&type=script&lang=js&"
export * from "./ListCourses.vue?vue&type=script&lang=js&"
import style0 from "./ListCourses.vue?vue&type=style&index=0&id=06dbe27e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dbe27e",
  null
  
)

export default component.exports